import PropTypes from 'prop-types';

import { Link } from 'react-router';

import { withStyles } from 'legacyStyles';

import { Button } from 'Components/LegacyButton';
import Title from 'Components/Title';
import { Typography } from 'Components/Typography';

import { goToDecider as content } from 'assets/content/consultation/consultation';

import BaseScene from './BaseScene';

const styles = {
  ctas: {
    display: 'flex',
    marginTop: 60,
    flexDirection: 'column',
    alignSelf: 'center',
    alignItems: 'center',
    justifyContent: 'center',
  },
};

const GoToDecider = ({ cartUrl, classes, hasSubscription, hasOrder }) => {
  return (
    <BaseScene justifyContent="start">
      <Title>{content.title}</Title>
      <Typography align="center" color="grey" variant="p2">
        {content.description}
      </Typography>

      <div className={classes.ctas}>
        {hasSubscription && (
          <>
            <Button Component={Link} to="/account/subscription/home" variant="vert">
              {content.ctaSeeSubscription}
            </Button>
            <Typography align="center" color="noir" variant="mono1">
              Or
            </Typography>
          </>
        )}
        <Button Component={Link} to={cartUrl} variant="vert">
          {hasSubscription || hasOrder ? content.ctaGoToCart : content.ctaOrderNow}
        </Button>
      </div>
    </BaseScene>
  );
};

GoToDecider.defaultProps = {
  hasSubscription: false,
};

GoToDecider.propTypes = {
  cartUrl: PropTypes.string.isRequired,
  classes: PropTypes.objectOf(PropTypes.string).isRequired,
  hasSubscription: PropTypes.bool,
  hasOrder: PropTypes.bool.isRequired,
};

export default withStyles(GoToDecider, styles);
